<template>
  <div>
    <b-alert show><i class="fa fa-bell mr-2" aria-hidden="true"></i>{{getAlertMesage}}</b-alert>
    <b-form-group 
      horizontal 
      :label-cols="3"
      v-if="$store.getters.signedRoles.includes('ADMIN_USER')" 
      label="¿Es Marketplace user?">
      <c-switch 
        inputType="checkbox" 
        type="text" 
        variant="success" 
        on="Si" 
        off="No" 
        :pill="true" 
        v-model="marketplaceUser" 
        size="m" 
        id="s0">
      </c-switch>
    </b-form-group>
    <hr v-if="$store.getters.signedRoles.includes('ADMIN_USER')"/>
    <b-form-group 
      horizontal 
      :label-cols="3"
      v-if="$store.getters.signedRoles.includes('ADMIN_USER') || $store.getters.signedRoles.includes('ORGANIZATION_ADMIN_USER')"
      label="¿Es Administrador?">
      <c-switch 
        inputType="checkbox" 
        type="text" 
        variant="success" 
        on="Si" 
        off="No" 
        :pill="true" 
        v-model="admin" 
        size="m" 
        id="s0">
      </c-switch>
    </b-form-group>
    <hr/>
    <b-form-group horizontal :label-cols="3" label="Permisos" v-if="$store.getters.signedRoles.includes('ADMIN_USER') || $store.getters.signedRoles.includes('ORGANIZATION_ADMIN_USER')">
      <b-form-checkbox-group
        v-model="roles"
        size="md"
        stacked
        :disabled="!($store.getters.signedRoles.includes('ADMIN_USER') || $store.getters.signedRoles.includes('ORGANIZATION_ADMIN_USER'))"
        :options="rolesOptions">
      </b-form-checkbox-group>
    </b-form-group>
  </div>
</template>
<script>
import {RoleService} from '@/mixims/AdminServiceMixin'
import cSwitch from '@/components/common/Switch'

export default {
  props: ['value', 'options'],
  mixins: [RoleService],
  components: {
    cSwitch
  },
  methods: {
    permitions (r) {
      return ['CATALOG_USER',
        'ORDERS_USER',
        'INVENTORY_USER',
        'CARRIERS_USER',
        'REPORTS_USER'].includes(r.roleName)
    },
    containsRole (role) {
      return Boolean(this.roles && this.roles
        .find(r => r.roleName === role))
    }
  },
  computed: {
    getAlertMesage () {
      if (this.marketplaceUser) {
        if (this.admin) {
          return 'Usuario Administrador, este usuario tendra la capacidad de poder crear usuarios Seller y Administradores'
        } else {
          return 'Usuario básico'
        }
      } else {
        if (this.admin) {
          return 'Usuario Administrador Seller, este usuario tendra la capacidad de poder crear usuarios Seller solo con los Sellers habilitados por el Administrador'
        } else {
          return 'Usuario standard'
        }
      }
    },
    rolesOptions () {
      return this.sortValidRoles(this.options)
        .filter(this.permitions)
        .map(r => {
          return {text: this.roleProperties[r.roleName].name, value: r}
        })
    },
    roles: {
      set (newVal) {
        if (!newVal) this.value.roles = [this.standardOption]
        else if (!Array.isArray(newVal)) this.value.roles = [newVal]
        else this.value.roles = newVal
        if (this.value.roles.filter(r => !this.permitions(r)).length === 0) {
          this.value.roles.push(this.standardOption)
        }
        if (!newVal) this.marketplaceUser = false
      },
      get () {
        return this.value.roles
      }
    },
    marketplaceUser: {
      set (newType) {
        if (newType) {
          this.adminOption = this.options.find(r => r.roleName === 'ADMIN_USER')
          this.standardOption = this.options.find(r => r.roleName === 'STANDARD_USER')
        } else {
          this.adminOption = this.options.find(r => r.roleName === 'ORGANIZATION_ADMIN_USER')
          this.standardOption = this.options.find(r => r.roleName === 'ORGANIZATION_STANDARD_USER')
        }
      },
      get () {
        return this.containsRole('ADMIN_USER') || this.containsRole('STANDARD_USER')
      }
    },
    adminOption: {
      set (newVal) {
        if (this.admin) {
          this.roles = this.roles.map(r => {
            if (r.roleName === this.adminOption.roleName) return newVal
            else return r
          })
        }
      },
      get () {
        return this.marketplaceUser ? this.options.find(r => r.roleName === 'ADMIN_USER') : this.options.find(r => r.roleName === 'ORGANIZATION_ADMIN_USER')
      }
    },
    standardOption: {
      set (newVal) {
        if (!this.admin) {
          this.roles = this.roles && Array.isArray(this.roles) && this.roles.length > 0 ? this.roles.map(r => {
            if (r.roleName === this.standardOption.roleName) return newVal
            else return r
          }) : [newVal]
        }
      },
      get () {
        return this.marketplaceUser ? this.options.find(r => r.roleName === 'STANDARD_USER') : this.options.find(r => r.roleName === 'ORGANIZATION_STANDARD_USER')
      }
    },
    admin: {
      set (newVal) {
        if (newVal) {
          this.roles = this.roles.map(r => {
            if (r.roleName === 'ORGANIZATION_STANDARD_USER' || r.roleName === 'STANDARD_USER') return this.adminOption
            else return r
          })
        } else {
          this.roles = this.roles.map(r => {
            if (r.roleName === 'ORGANIZATION_ADMIN_USER' || r.roleName === 'ADMIN_USER') return this.standardOption
            else return r
          })
        }
      },
      get () {
        return this.containsRole('ADMIN_USER') || this.containsRole('ORGANIZATION_ADMIN_USER')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/RolesCheckbox.vue